import React from "react";
import "../../src/css/policy.css";
import LocationSlider from "./LocationSlider";

const Terms_conditon = () => {
  return (
    <>
      <div className="main-policy">
        <section className="terms-header">
          <h1>Terms and Conditions</h1>
          <p className="last-updated">Last Updated: January 2026</p>
        </section>

        <section className="terms-container">
          <p>
            By registering an account on{" "}
            <a
              href="https://launchestore.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://launchestore.com/
            </a>{" "}
            (the "Platform"), you agree to the following terms. If you do not
            agree, you may not use our services.
          </p>

          <h2>A. Nature of Service</h2>
          <p>
            LaunchEStore is a SaaS (Software as a Service) provider. We provide
            tools for businesses to create custom websites, mobile applications,
            and POS systems. We do not participate in the actual transactions
            between a Business Owner and their customers.
          </p>

          <h2>B. User Responsibility and Content</h2>
          <ul>
            <li>
              <strong>Information Accuracy:</strong> All information provided
              for the business website (domain, payment gateway details, product
              descriptions, pricing, etc.) is provided by the User.
            </li>
            <li>
              <strong>No Validation:</strong> LaunchEStore does not authorize,
              verify, or validate the information provided by the User.
            </li>
            <li>
              <strong>Liability for Fraud:</strong> Any fraud, misleading
              information, or illegal activity conducted through a website
              created on our platform is the sole responsibility of the Business
              Owner.
            </li>
            <li>
              <strong>Compliance:</strong> Users are responsible for ensuring
              their business complies with local laws, including tax and
              consumer protection regulations.
            </li>
          </ul>

          <h2>C. Order and Product Management</h2>
          <ul>
            <li>
              <strong>Direct Interaction:</strong> All products, inventory, and
              orders are managed individually by the Business Owner.
            </li>
            <li>
              <strong>No Intervention:</strong> LaunchEStore is not responsible
              for order fulfillment, shipping, product quality, or refunds.
            </li>
            <li>
              <strong>Disputes:</strong> Any disputes between a business and its
              customers must be resolved directly between those parties.
              LaunchEStore will not act as an arbitrator.
            </li>
          </ul>

          <h2>D. Digital Data and Conduct</h2>
          <ul>
            <li>
              <strong>Violation of Rights:</strong> LaunchEStore is not
              responsible for any digital data violations (such as copyright
              infringement or unauthorized use of trademarks) committed by the
              Business Owner.
            </li>
            <li>
              <strong>Termination:</strong> We reserve the right to suspend or
              terminate any account found to be engaging in fraudulent or
              illegal activities without prior notice.
            </li>
          </ul>
        </section>
      </div>

      <LocationSlider />
    </>
  );
};

export default Terms_conditon;
